import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import { StyledContainerSimpleMethod } from '../sideBarComponentsStyles';

interface SideBarSimpleMethodItemProps {
  name: string;
  action: () => void;
  successAction: boolean;
  textSuccess: string;
  loading?: boolean;
  colorText?: string;
  icon?: React.ReactNode;
}

export const SideBarSimpleMethodItem = ({
  name,
  action,
  successAction,
  textSuccess,
  loading = false,
  colorText,
  icon
}: SideBarSimpleMethodItemProps) => {
  useEffect(() => {
    if (successAction) {
      toast.success(textSuccess);
    }
  }, [successAction, textSuccess]);

  return (
    <StyledContainerSimpleMethod
      onClick={!loading ? action : undefined}
      type="button"
      disabled={loading}
      color={colorText}
    >
      {loading ? (
        <CircularProgress
          size={18}
          thickness={5}
          sx={{ color: colorText || 'inherit' }}
        />
      ) : (
        <>
          {icon && icon}
          {name}
        </>
      )}
    </StyledContainerSimpleMethod>
  );
};
